// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qN8Q","index":"styles_index__1TpiC"};